import View from './view';
import {Props} from './model';
import {useSelector} from 'react-redux';
import {profileNotificationsByStatusSelector} from '../../../redux/selectors/profile';
import {NotificationStatus} from '../../models/profile/notification';

export const UnreadNotificationsCounter = (props: Props) => {
  const notifications = useSelector(profileNotificationsByStatusSelector(NotificationStatus.NotRead));
  return View({
    ...props,
    count: notifications.length,
  });
};
